// src/components/PrivateRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PrivateRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="p-4">Checking auth...</div>;
  }

  if (!user) {
    // ❌ 未登录，跳回登录页
    return <Navigate to="/login" replace />;
  }

  // ✅ 已登录，渲染子路由（Dashboard 等）
  return <Outlet />;
}
